import axios from 'axios';
import { getAPIUrl, getLoggerUrl, getLoggerApiIndex } from './utils/urlFactory';
import { store } from './index';
import { v4 as uuidv4 } from 'uuid';
import { Logtail } from '@logtail/browser';

const logtail = new Logtail(process.env.NEXT_PUBLIC_BETTER_STACK_SOURCE_TOKEN);

const verifyRoomAccessing = async (id) => {
  return axios
    .get(`${getAPIUrl()}/api/rooms/${id}/accessing`)
    .then((res) => {
      return res.data;
    });
};

const joinRoom = async (id, password) => {
  return axios
    .patch(`${getAPIUrl()}/api/rooms/${id}/join`, {
      password,
    })
    .then((res) => {
      return res.data;
    });
};

const endRoom = async (id) => {
  return axios
    .patch(`${getAPIUrl()}/api/rooms/${id}/end`)
    .then((res) => {
      return res.data;
    });
};

const uploadRecordAudio = async (formData) => {
  return axios
    .post(`${getAPIUrl()}/api/upload/record-audio`, formData, {
        headers: {
            'strapiToken': `Bearer ${store.getState().strapiToken}`,
            'Content-Type': 'multipart/form-data',
        }
      },
    )
    .then((res) => {
      return res.data;
    });
};

const sendLoggerPermission = async (data) => {
  await logtail.info('',{
    APP_NAME: "friday-web",
    LOGTYPE: "access",
    REQUEST_ID: uuidv4(),
    REQUEST_METHOD: "POST",
    REQUEST_URI: "/",
    REQUEST_BODY: JSON.stringify(data),
  });
};





export default {
  verifyRoomAccessing,
  joinRoom,
  endRoom,
  uploadRecordAudio,
  sendLoggerPermission
};
